import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LodableProfileScene = Loadable({
  loader: () => import('./ProfileSceneContainer.js'),
  loading: LoadingIndicatorFull,
})

export default LodableProfileScene
